import { flowRight as compose } from 'lodash';

import withUser from '~lib/common/hoc/withUser';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';
import withTTS from '~lib/common/hoc/withTTS';

import CaseQuestions from './CaseQuestions.vue';
import questionQueries from '~lib/common/queries/Question';

import voiceQueries from '~lib/common/queries/Voice';

const enhance = compose(
  dataView({
    queries: {
      fetch: questionQueries.fetch,
      add: questionQueries.add,
      save: questionQueries.save,
      remove: questionQueries.remove,
    },
  }),
  renameProps({ data: 'questions' }),
  dataView({ queries: voiceQueries }),
  renameProps({ data: 'voices' }),
  withTTS(),
  withUser(),
);

export default enhance(CaseQuestions);
